import type { Channel } from '~publish/gql/graphql'

import { Card, Flex, Heading, Notice, Text } from '@buffer-mono/popcorn'

import { CommentsList } from '../CommentsList'
import { CommentsScore } from './CommentsScore'

import styles from './OverviewPage.module.css'

export const OverviewPage = ({
  channel,
}: {
  channel: Channel
}): JSX.Element => {
  const noop = (): void => {
    // This is a noop function to satisfy the type signature of the CommentsList component.
  }
  return (
    <>
      <Notice variant="info" className={styles.notice}>
        <Notice.Heading>Work in Progress 🏗️</Notice.Heading>
        <Notice.Text>
          We&apos;re actively working on comments! Check back soon for
          engagement metrics, conversation tracking, and superfan
          identification.
        </Notice.Text>
      </Notice>
      <Flex direction="row" gap="md" className={styles.container}>
        <Flex direction="column" gap="md" className={styles.leftColumn}>
          <Card className={styles.card}>
            <Heading as="h3" size="small">
              Featured Comments
            </Heading>
            <div className={styles.contentWrapper}>
              <CommentsList
                channel={channel}
                hasActiveFilters={false}
                onClearFilters={noop}
              />
            </div>
          </Card>
          <Card className={styles.card}>
            <Heading as="h3" size="small">
              Conversations
            </Heading>
            <Flex direction="column" className={styles.centerContent}>
              <Text size="md">Conversations will go here</Text>
            </Flex>
          </Card>
          <Card className={styles.card}>
            <Heading as="h3" size="small">
              Mentions
            </Heading>
            <Flex direction="column" className={styles.centerContent}>
              <Text size="md">Mentions will go here</Text>
            </Flex>
          </Card>
        </Flex>

        <Flex direction="column" gap="md" className={styles.rightColumn}>
          <Card className={styles.panel}>
            <Heading as="h3" size="small">
              Comments Score
            </Heading>
            <Text size="sm" color="subtle">
              Rates your ability to stay engaged with your audience.
            </Text>
            <CommentsScore channel={channel} />
          </Card>
          <Card className={styles.panel} style={{ height: '315px;' }}>
            <Heading as="h3" size="small">
              Superfans
            </Heading>
            <Text size="sm" color="subtle">
              Superfans will go here
            </Text>
          </Card>
        </Flex>
      </Flex>
    </>
  )
}
